import { createContext, useContext, useEffect, useState } from 'react';
import SearchController from '../controllers/SearchController.ts';
import { SearchResult } from '../models/search/searchResult.ts';
import { SearchParam } from '../models/searchParams/searchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';

type SearchContextType = {
    isLoaded?: boolean;
    results: SearchResult[];
    totalCount: number;
    searchParam: SearchParam;
    setSearchParam: (searchParam: SearchParam) => void;
    tableSearchParam: TableSearchParam;
    setTableSearchParam: (tableSearchParam: TableSearchParam) => void;
};

const SearchContext = createContext<SearchContextType>({} as SearchContextType);

export const SearchContextProvider = ({ children }: { children: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [results, setResults] = useState<SearchResult[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [searchParam, setSearchParam] = useState<SearchParam>({ searchTerm: /*//todo: sessionStorage.getItem('searchTerm') ||*/ '', searchType: /*//todo: sessionStorage.getItem('searchType') ||*/ '' });
    const [tableSearchParam, setTableSearchParam] = useState<TableSearchParam>({ offset: 0, limit: 24 });

    const fetchResults = async () => {
        try {
            setIsLoaded(false);
            const result = await SearchController.get(searchParam, tableSearchParam);
            setResults(result.results);
            setTotalCount(result.totalCount);
        } catch (error) {
            console.error('Error fetching results:', error);
        } finally {
            setIsLoaded(true);
        }
    };
    useEffect(() => {
        if (searchParam.searchType)
            fetchResults();
    }, [searchParam, tableSearchParam]);

    const fetchNutritionalValues = async () => {
        try {
            const nutritionalValues = await SearchController.getNutritionalValues(results);
            setResults(
                ((prevResults) => prevResults.map(result => ({
                    ...result,
                    nutritionalValues: nutritionalValues.nutritionalValues.filter(nv => nv.resultID == result.resultID && nv.type == result.type)[0] ?? null
                }))));
        } catch (error) {
            console.error('Error fetching nutritional values:', error);
        }
    }
    useEffect(() => {
        if (results.length == 0) return;
        if (results[0].nutritionalValues) return;
        fetchNutritionalValues();

    }, [results]);

    const context: SearchContextType = {
        isLoaded,
        results,
        totalCount,
        searchParam,
        setSearchParam,
        tableSearchParam,
        setTableSearchParam,
    }

    return (
        <SearchContext.Provider value={context}>
            {children}
        </SearchContext.Provider>
    )
}

export const useSearchContext = () => useContext(SearchContext)
